"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var escapeStrForRegex = function escapeStrForRegex(str) {
  return (str || '').replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};

var _default = function _default(str) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? 'i' : _ref$modifiers;

  return new RegExp(escapeStrForRegex(str), modifiers);
};

exports["default"] = _default;